// Library imports
import React, { useEffect, useRef } from "react";

// User Component imports
import { VARIABLE_INFO } from "../utils/promptVariables";

/**
 * 変数の候補リスト（{name}＋説明＋値の例）
 * 項目は mousedown で確定し、エディタのフォーカスを外さない
 */
const VariableMenu = ({ items, activeIndex, style, onSelect, onHover }) => {
    const listRef = useRef(null);

    // 選択中の行が見えるようにする
    useEffect(() => {
        const el = listRef.current && listRef.current.children[activeIndex];
        if (el) el.scrollIntoView({ block: "nearest" });
    }, [activeIndex]);

    return (
        <div className="ops-var-menu" style={style} onMouseDown={(e) => e.preventDefault()}>
            <div className="ops-var-list" ref={listRef} role="listbox">
                {items.map((name, i) => {
                    const info = VARIABLE_INFO[name];
                    return (
                        <div key={name} role="option" aria-selected={i === activeIndex}
                            className={"ops-var-item" + (i === activeIndex ? " is-active" : "")}
                            onMouseDown={(e) => { e.preventDefault(); onSelect(name); }}
                            onMouseEnter={() => onHover(i)}>
                            <div className="ops-var-item-head">
                                <code>{"{" + name + "}"}</code>
                                {info && <span className="ops-var-label">{info.label}</span>}
                            </div>
                            {info && info.example && <div className="ops-var-example">例: {info.example}</div>}
                        </div>
                    );
                })}
            </div>
            <div className="ops-var-hint">↑↓ で選択 ／ Enter・Tab で挿入 ／ Esc で閉じる</div>
        </div>
    );
};

export default VariableMenu;
